var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RoomHeader',{attrs:{"msg":"My Infinity"}}),_c('p',[_vm._v("Tous nos techniciens sont occupés. Nous mettons tout en oeuvre pour vous répondre au plus vite.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }